// WelcomePopup - Disabled as per user request
export function WelcomePopup() {
  return null;
}
